import { render, staticRenderFns } from "./InvoiceV1.vue?vue&type=template&id=58150a8a&"
import script from "./InvoiceV1.vue?vue&type=script&lang=js&"
export * from "./InvoiceV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports